<div class="card mb-4 rounded-3 shadow-sm">
  <div class="card-header py-3"><!-- Head -->
    <h4 class="my-0 fw-normal fs-5"><i class="bi bi-sliders2 me-2"></i>
      Priviliege Level | Edit
    </h4>
  </div>
  <div class="ps-2 ">
    <div class="card-body fs-6"><!-- หัว Search Name -->
      <p class="fw-semibold">Name</p>
      <div class="col-11">
        <div class="input-group">
          <input id="InputName" type="text " class="form-control " placeholder="Input Name Privilege" />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row"><!-- Register free ,Start Point,Point Level -->
        <div class="col">
          <p class="fw-semibold">Register free (Baht)</p>
          <div class="d-flex gap-2 align-items-center mb-4">
            <div class="row justify-content-between">
              <div class="col-11">
                <div class="input-group">
                  <input id="InputBaht" type="text " class="form-control me-4" placeholder="Register free (Baht)" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <p class="fw-semibold">Start Point</p>
          <div class="d-flex gap-2 align-items-center mb-4">
            <div class="row justify-content-between">
              <div class="col-11">
                <div class="input-group">
                  <input id="InputStart_Point" type="text " class="form-control me-4" placeholder="Start Point" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <p class="fw-semibold">Point Level</p>
          <div class="d-flex gap-2 align-items-center mb-4">
            <div class="row justify-content-between">
              <div class="col-11">
                <div class="input-group">
                  <input id="InputPoint_Level" type="text " class="form-control me-4" placeholder="Point Level" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body my-2">
        <p class="fw-semibold">Search patron type</p><!--Search patron type-->
        <div class="row justify-content-between mb-3 pe-3">
          <div class="col-11">
            <div class="input-group">
              <input id="myInput" type="text " class="form-control"
                placeholder="Fill patron type name " />
            </div>
          </div>
          <div class="col-1 text-end my-auto">
            <a id="test" role="button" class="btn-primary">
              <i class="bi bi-plus-circle-fill fs-icon-2"></i>
            </a>
          </div>
        </div>

        <ul class="list-group list-group-flush"><!-- ตาราง Search -->
          <li class="list-group-item mb-2 d-flex gap-2 justify-content-between align-items-start ">

            <div class="col-10">Teacher</div>
            <div class="col-1 text-end showToast pe-3">
              <a role="button" class="btn-danger"><i class="bi bi-x-circle-fill"></i></a>
            </div>
          </li>
          <li class="list-group-item mb-2 d-flex gap-2 justify-content-between align-items-start ">

            <div class="col-10">Student</div>
            <div class="col-1 text-end showToast pe-3">
              <a role="button" class="btn-danger"><i class="bi bi-x-circle-fill"></i></a>
            </div>
          </li>
          <li class="list-group-item mb-2 d-flex gap-2 justify-content-between align-items-start ">

            <div class="col-10">Staff</div>
            <div class="col-1 text-end showToast pe-3">
              <a role="button" class="btn-danger" ><i class="bi bi-x-circle-fill"></i></a>
            </div>
          </li>
          <li class="list-group-item mb-2 d-flex gap-2 justify-content-between align-items-start "></li>
        </ul>
        <div class="form-check form-switch mb-4"><!--Check label 95-102 -->
          <input class="form-check-input" type="checkbox" role="switch" id="flexPrivileNotiOpen">
          <label class="form-check-label fw-semibold" for="flexPrivileNotiOpen">Open Privilege</label>
        </div>
        <div class="form-check form-switch mb-4">
          <input class="form-check-input" type="checkbox" role="switch" id="flexPrivileNotiOpen">
          <label class="form-check-label fw-semibold" for="flexPrivileNotiOpen">Number can transfer point</label>
        </div>
        <div><br></div>
        <div class="container-center"><!-- Button -->
          <div class="row">
            <div class="col-sm-5">
              <button type="button" class="w-23 btn btn-sm btn-outline-danger">Delete</button>
            </div>
            <div class="col-sm-5">
              <button type="button" class="w-23 btn btn-sm btn-outline-warning">Cancel</button>&nbsp; &nbsp;
              <button type="button" class="w-23 btn btn-sm btn-outline-success">Save</button>
            </div>
            <div class="col-sm-2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
